import { render } from "./EmailCard.vue?vue&type=template&id=7aef4d02"
import script from "./EmailCard.vue?vue&type=script&lang=js"
export * from "./EmailCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__